import { render, staticRenderFns } from "./MultiResourceSummaryComponent.vue?vue&type=template&id=f7bc6c30"
import script from "./MultiResourceSummaryComponent.vue?vue&type=script&lang=js"
export * from "./MultiResourceSummaryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports